import React from "react";
import { File, FileText, Image, Music, Video, Presentation, FileImage } from "lucide-react";

// SVGs for PDF and Word icons (simple versions)
// Custom SVG for PDF icon (Adobe-style)
const PdfSVG = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="3" fill="#E53E3E" />
    <path d="M7 17c2-3 4-7 7-7" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M10.5 13.5c1.5 1.5 3.5 2.5 5.5 2" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M12 7c.5 2.5 2.5 6.5 4.5 8.5" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
    <rect x="2" y="2" width="20" height="20" rx="3" stroke="#B91C1C" strokeWidth="1.5" />
  </svg>
);
const WordSVG = ({ className }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="20" height="20" rx="3" fill="#3182CE" />
    <rect x="6" y="6" width="12" height="12" rx="2" fill="#fff" />
    <text x="12" y="16" textAnchor="middle" fontSize="7" fill="#3182CE" fontWeight="bold">W</text>
  </svg>
);

type FileType = "document" | "image" | "video" | "audio" | "powerpoint" | "pdf" | "word" | "other";

interface FileIconProps {
  type: FileType;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const FileIcon = ({ type, size = "md", className = "" }: FileIconProps) => {
  const iconSize = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-8 w-8" : "h-6 w-6";
  
  switch (type) {
    case "document":
      return <FileText className={`${iconSize} text-blue-500 ${className}`} />;
    case "image":
      return <FileImage className={`${iconSize} text-green-500 ${className}`} />;
    case "video":
      return <Video className={`${iconSize} text-purple-500 ${className}`} />;
    case "audio":
      return <Music className={`${iconSize} text-yellow-500 ${className}`} />;
    case "powerpoint":
      return <Presentation className={`${iconSize} text-orange-500 ${className}`} />;
    case "pdf":
      return <PdfSVG className={iconSize + ' ' + className} />;
    case "word":
      return <WordSVG className={iconSize + ' ' + className} />;
    default:
      return <File className={`${iconSize} text-gray-500 ${className}`} />;
  }
};

export default FileIcon;